/**
 * Returns the first day of the current month.
 * Updates once a month.
 * Examples:
 * - Any day in December 2025: "2025-12-01"
 * - Any day in January 2026: "2026-01-01"
 */
export const getUpdatedDate = (): string => {
  const today = new Date();
  
  // Get the first day of the current month
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  
  return firstDayOfMonth.toLocaleDateString('sv-SE');
};
